import axios from "axios";
import { BASE_URL } from "./baseUrl";
import { getClientSource } from "./Functions";

async function fetchFinanceDocumentAttachmentBlob(documentId, attachmentType) {
  const accessToken = localStorage.getItem("accessToken");
  const path =
    attachmentType === "invoice"
      ? `/api/finance/documents/${documentId}/invoice`
      : `/api/finance/documents/${documentId}/upi-screenshot`;

  const res = await axios.get(`${BASE_URL}${path}`, {
    responseType: "arraybuffer",
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      company_source: getClientSource(),
    },
    validateStatus: () => true,
  });

  if (res.status === 401) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  if (res.status !== 200) {
    throw new Error("Could not load the finance document attachment.");
  }

  const contentType = res.headers["content-type"] || "application/octet-stream";
  return new Blob([res.data], { type: contentType });
}

/**
 * Loads a finance document through the API (Bearer auth). Raw binary stream — not encrypted JSON.
 */
export async function fetchFinanceDocumentBlob(documentId) {
  const accessToken = localStorage.getItem("accessToken");
  const res = await axios.get(`${BASE_URL}/api/finance/documents/${documentId}/view`, {
    responseType: "arraybuffer",
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      company_source: getClientSource(),
    },
    validateStatus: () => true,
  });

  if (res.status === 401) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  if (res.status !== 200) {
    throw new Error("Could not load the finance document.");
  }

  const contentType = res.headers["content-type"] || "application/octet-stream";
  return new Blob([res.data], { type: contentType });
}

export function fetchFinanceDocumentInvoiceBlob(documentId) {
  return fetchFinanceDocumentAttachmentBlob(documentId, "invoice");
}

export function fetchFinanceDocumentUpiScreenshotBlob(documentId) {
  return fetchFinanceDocumentAttachmentBlob(documentId, "upi-screenshot");
}

export function isPdfMimeType(mimeType) {
  return String(mimeType || "").toLowerCase().includes("pdf");
}

export function isImageMimeType(mimeType) {
  return String(mimeType || "").toLowerCase().startsWith("image/");
}
